import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { toggleFlag } from './toggleFlag';

export const intentVerification: FormSnippet<
  DiscoverySettingsObject,
  { intentVerification: boolean }
> = {
  render: ({ form }) => (
    <>
      <FormSwitch
        control={form.control}
        name='intentVerification'
        label='Compute Intent Verification Rules'
        description='Disable to have faster snapshot. It could have some impact on table views, graphs and cell coloring.'
      />
    </>
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.intentVerification =
      !model.disabledPostDiscoveryActions?.includes('intentVerification');
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.disabledPostDiscoveryActions ??= [];

    modelDraft.disabledPostDiscoveryActions = toggleFlag(
      modelDraft.disabledPostDiscoveryActions,
      'intentVerification',
      transformedValues.intentVerification,
    );
  },
  schema: z.object({
    intentVerification: z.boolean(),
  }),
};
